import moment from "moment";
import React from "react";
import { marpolSelectors } from "../../../../../redux/app/marpol";
import { TBFL1Record } from "../../../../../redux/app/bfl-1/@types";
import { TBFL1B1 } from "../../../../../redux/app/bfl-1/groups/group-b";
import BFL1TableRows from "../BFL1TableRows";
import { IStore } from "../../../../../redux/store";
import { ConnectedProps, connect } from "react-redux";

type OwnProps = {
	bfl1Record: TBFL1Record;
	isStrikedOff?: boolean;
};
type BFL1B1PreviewProps = React.PropsWithChildren<OwnProps>;
function BFL1B1Preview(props: BFL1B1PreviewProps) {
	const bfl1Record = props.bfl1Record as TBFL1B1;
	const { item1, item2, item3, item4, item5, item6 } = bfl1Record;

	const operationDate = moment(bfl1Record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<BFL1TableRows
				record={bfl1Record}
				tableRows={[
					[operationDate, "B", "1", renderItemB1()],
					[null, null, "2", renderItemB2()],
					[null, null, "3", renderItemB3()],
					[null, null, "4", renderItemB4()],
					[null, null, "5", renderItemB5()],
					[null, null, "6", renderItemB6()],
					[null, null, "NOTE", bfl1Record.remarks],
				]}
			/>
		);
	}

	function renderItemB1() {
		if (item1.place === "PORT")
			return (
				<h6>
					{operationDate}, {item1.portName}
				</h6>
			);
		return (
			<h6>
				{operationDate}, <br />
				{item1.position.latitude}, {item1.position.longitude}
			</h6>
		);
	}

	function renderItemB2() {
		if (bfl1Record.item2.remarks) return bfl1Record.item2.remarks;
		return null;
	}

	function renderItemB3() {
		if (bfl1Record.item3.remarks) return bfl1Record.item3.remarks;
		return null;
	}

	function renderItemB4() {
		if (bfl1Record.item4.remarks) return bfl1Record.item4.remarks;
		return null;
	}

	function renderItemB5() {
		if (bfl1Record.item5.remarks) return bfl1Record.item5.remarks;
		return null;
	}

	function renderItemB6() {
		if (bfl1Record.item6.remarks) return bfl1Record.item6.remarks;
		return null;
	}

	function renderBlank() {
		return <h1 className="invisible">HELLO WORLD</h1>;
	}

	return renderMain();
}

export default BFL1B1Preview;
